import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/roles` — l'elenco dei ruoli, tolto il 02-11-2026 insieme alla scheda `/roles/<id>`: l'elenco era
 * più povero di «Utenti e ruoli» (Organizzazione), e la modifica dei permessi di un ruolo è anche
 * in «Permessi, ruoli & rotte». L'indirizzo resta come rinvio, per i preferiti e i collegamenti salvati.
 */
export const Route = createFileRoute('/_app/roles')({
  beforeLoad: () => { throw redirect({ to: '/organization/permissions', replace: true }); },
});
